import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PiiAuditService, AuditReason } from 'src/app/_services/pii-audit.service';

@Component({
  selector: 'app-pii-unhide-modal',
  templateUrl: './pii-unhide-modal.component.html',
  styleUrls: ['./pii-unhide-modal.component.scss']
})
export class PiiUnhideModalComponent implements OnInit {
  unhideForm: FormGroup;
  auditReasons: AuditReason[] = [];
  loading = false;
  fieldName = '';
  userId = '';
  context = 'field'; // 'field' for form inputs, 'cell' for grid cells

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private piiAuditService: PiiAuditService
  ) {
    this.unhideForm = this.fb.group({
      reasonId: ['', Validators.required],
      comment: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit(): void {
    this.loadAuditReasons();
  }

  /**
   * Load audit reasons from API
   */
  loadAuditReasons(): void {
    this.loading = true;
    this.piiAuditService.getAuditReasons().subscribe({
      next: (reasons) => {
        this.auditReasons = reasons;
        this.loading = false;
      },
      error: (error) => {
        console.error('Failed to load audit reasons:', error);
        // Fallback reasons if API fails
        this.auditReasons = [
          { reasonCode: 'RC001', description: 'Customer Identity Verification' },
          { reasonCode: 'RC012', description: 'Audit Review' },
          { reasonCode: 'RC002', description: 'Transaction Dispute Resolution' },
          { reasonCode: 'RC039', description: 'Account Login or Access Issue Resolution' }
        ];
        this.loading = false;
      }
    });
  }

  /**
   * Submit the unhide request
   */
  onSubmit(): void {
    if (this.unhideForm.valid) {
      const formValue = this.unhideForm.value;
      const selectedReason = this.auditReasons.find(r => r.reasonCode === formValue.reasonId);
      
      const result = {
        reasonId: formValue.reasonId,
        reason: selectedReason?.description || '',
        comment: formValue.comment,
        fieldName: this.fieldName,
        userId: this.userId
      };
      
      this.activeModal.close(result);
    } else {
      this.markFormGroupTouched();
    }
  }

  /**
   * Cancel the unhide request
   */
  onCancel(): void {
    this.activeModal.dismiss('cancel');
  }

  /**
   * Mark all form fields as touched to show validation errors
   */
  private markFormGroupTouched(): void {
    Object.keys(this.unhideForm.controls).forEach(key => {
      const control = this.unhideForm.get(key);
      control?.markAsTouched();
    });
  }

  /**
   * Get form control for template access
   */
  get f() {
    return this.unhideForm.controls;
  }
} 